import History from "@/models/storePanel/History";

export default {
    namespaced: true,

    state: () => ({
        pointAnalysis: [],
        monthlyPoints: [],
        exportMonthlyPoints: null,
        exportPointAnalysis: null
    }),

    mutations: {
        setPointAnalysis(state, payload) {
            state.pointAnalysis = payload
        },

        setMonthlyPoints(state, payload) {
            state.monthlyPoints = payload;
        },

        setExportMonthlyPoints(state, payload){
            state.exportMonthlyPoints = payload
        },

        setExportPointAnalysis(state, payload){
            state.exportPointAnalysis = payload
        }
    },

    actions: {
        async getPointAnalysis({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                let filter = ""
                Object.keys(body.filters).map((key) => {
                    if(body.filters[key]){
                        filter += "&" + key + "=" + body.filters[key]   
                    }
                })

                const { data } = await History.getPointAnalysis(body.query + filter)

                const { pagination } = data.data;
                const coupons = data.data.data;

                commit("setPointAnalysis", coupons);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },

        async getMonthlyPoints({ commit }, query) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await History.getMonthlyPoints(query)

                const { monthly_store_point_history, pagination } = data.data;

                commit("setMonthlyPoints", monthly_store_point_history);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },

        async getExportedFileStatus({ commit }, type) {
            try {
                commit("setLoading", true, { root: true });

                let data = {}

                if(type == 1){
                    data = await History.getExportedMonthlyPointsStatus()
                    commit("setExportMonthlyPoints", data.data.data)
                }else{
                    data = await History.getExportedPointAnalysisStatus()
                    commit("setExportPointAnalysis", data.data.data)
                }

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async exportFile({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                let data = {}

                if(body.mode == 1){
                    data = await History.exportMonthlyPoints()
                    commit("setExportMonthlyPoints", data.data.data)
                }else{
                    data = await History.exportPointAnalysis({date_period: body.date_period})
                    commit("setExportPointAnalysis", data.data.data)
                }

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedFile({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                if(body.status == 1){
                    await History.deleteExportedMonthlyPoints(body.id)
                    commit("setExportMonthlyPoints", null)
                }else{
                    await History.deleteExportedPointAnalysis(body.id)
                    commit("setExportPointAnalysis", null)
                }

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        }
    }
};
